import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/clientUpgrade',
  title: window.language['menu.client.upgrade'],
  component: dynamicWrapper(app, [import('../../HomePage/model'),import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);



// WEBPACK FOOTER //
// ./src/routes/Client/ClientUpgrade/index.js